var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spnod-admin__form--container container mx-0 w-100 h-100",
    class: _vm.isMobile ? 'px-0' : 'px-3'
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('b-input-group', {
    staticClass: "mb-2"
  }, [_c('b-form-input', {
    staticClass: "mb-0",
    attrs: {
      "name": "password",
      "state": _vm.validateState('password'),
      "type": _vm.isPasswordDisplayed,
      "placeholder": "Password",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.password.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.password, "$model", $$v)
      },
      expression: "$v.form.password.$model"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('span', {
    staticClass: "input-group-text small spnod-cursor",
    on: {
      "click": function($event) {
        return _vm.handlePassToggle('password')
      }
    }
  }, [(!_vm.showPassword) ? _c('i', {
    staticClass: "fa fa-eye fa-sm"
  }) : _c('i', {
    staticClass: "fa fa-eye-slash fa-sm"
  })])]), _vm._v(" "), _c('b-form-invalid-feedback', [_vm._v("\n        Password must be at least 8 characters long and contain at least 1 capital letter, 1 number and 1 symbol\n      ")])], 1), _vm._v(" "), _c('b-input-group', {
    staticClass: "mb-4"
  }, [_c('b-form-input', {
    staticClass: "mb-0",
    attrs: {
      "name": "password2",
      "state": _vm.validateState('password2'),
      "type": _vm.isConfirmDisplayed,
      "placeholder": "Confirm Password",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.password2.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.password2, "$model", $$v)
      },
      expression: "$v.form.password2.$model"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('span', {
    staticClass: "input-group-text small spnod-cursor",
    on: {
      "click": function($event) {
        return _vm.handlePassToggle('confirm')
      }
    }
  }, [(!_vm.showConfirm) ? _c('i', {
    staticClass: "fa fa-eye fa-sm"
  }) : _c('i', {
    staticClass: "fa fa-eye-slash fa-sm"
  })])]), _vm._v(" "), _c('b-form-invalid-feedback', [_vm._v("\n        Must match password\n      ")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "spnod-admin__form--list"
  }, [_c('li', [_c('router-link', {
    staticClass: "spnod-admin__form--link",
    attrs: {
      "id": "login",
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1)]), _vm._v(" "), (_vm.resetPasswordErrors.length > 0) ? _c('ul', {
    staticClass: "spnod-text--error spnod-text--center"
  }, _vm._l((_vm.resetPasswordErrors), function(error) {
    return _c('li', {
      staticClass: "spnod-list__item"
    }, [_vm._v("\n          " + _vm._s(error) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('b-form-group', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "submit",
      "size": "sm",
      "disabled": _vm.isDisabled
    }
  }, [(!_vm.isSending) ? _c('p', [_vm._v("Send")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72c792dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Forms/ResetPasswordForm.vue
// module id = E9uE
// module chunks = 2